<template>
  <keep-alive :include="keepAliveNames" :max="maxKeptAlive">
    <router-view />
  </keep-alive>
</template>

<script>
// Layouts render their own <router-view/>, so keep-alive has to wrap it here (not in App.vue).
// Which pages are cached, and how many, is configured in utils/keepAlive.js.
import { keepAliveNames } from "@/router";
import { MAX_KEPT_ALIVE } from "@/utils/keepAlive";

export default {
  name: "KeptRouterView",
  data: () => ({ keepAliveNames, maxKeptAlive: MAX_KEPT_ALIVE }),
};
</script>
